// material-ui

import { Backdrop } from '@mui/material';
import CircularLoader from './CircularLoader';

// ==============================|| CIRCULAR LOADER ||============================== //
const BackdropLoader = ({ open }) => (
  <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
    <CircularLoader />
  </Backdrop>
);

export default BackdropLoader;
